import React from "react";
import { Button, useMantineTheme } from "@mantine/core";
import Segment from "../services/model/Segment";

type SegmentActionButtonsProps = {
  segment: Segment;
  onView: (segment: Segment) => void;
};

const SegmentActionButtons: React.FC<SegmentActionButtonsProps> = ({
  segment,
  onView,
}) => {
  const theme = useMantineTheme();
  const primaryKey = theme.primaryColor;
  const primaryColor = theme.colors[primaryKey][5];

  return (
    <Button
      variant="outline"
      size="xs"
      color="dark"
      radius={6}
      onClick={() => onView(segment)}
      styles={{
        root: {
          borderColor: primaryColor,
          color: primaryColor,
          fontWeight: 600,
        },
      }}
    >
      View
    </Button>
  );
};

export default SegmentActionButtons;
